export default "__VITE_ASSET__56795c4a__"